<template>
	<type-wrapper class="type-L" limit @mouseenter="mouseInto = true" @mouseleave="mouseInto = false">
		<transition enter-active-class="enter-into" leave-active-class="leave-out" v-for="(item, index) in showData" @after-enter="afterEnter" :key="index" appear>
			<type-grid row="1" v-show="curIndex === index" class="type-L-item">
				<type-content large class="type-L-content">"{{ item.content }}"</type-content>
				<div class="type-L-photo">
					<img :src="item.logo || userPhoto" alt="">
				</div>
				<div class="type-L-name-title">
					<type-content medium padding="0" v-if="item.name">{{ item.name }}</type-content>
					<type-content small padding="0" v-if="item.title">{{ item.title }}</type-content>
				</div>
			</type-grid>
		</transition>
	</type-wrapper>
</template>

<script>
	// 自动翻页N条评价
	import mixin from '../mixin.js'
	export default {
		name: 'type-L',
		mixins: [ mixin ],
		data() {
			return {
				curIndex: 0,
				mouseInto: false,
				recordIndex: 0
			}
		},
        mounted() {
            // if (this.typeData.id) {
            //     const parentDiv = document.querySelector('#' + this.typeData.id);
            //     const heightList = Array.from(parentDiv.childNodes).map(div => div.offsetHeight || 0);
            //     // const maxHeight = childList.find(div => )
            //     console.clear()
            //     console.log(heightList)
            // }
        },
		methods: {
			afterEnter() {
				this.recordIndex = (this.recordIndex + 1) === this.showData.length ? 0 : (this.recordIndex + 1);
				if (this.mouseInto === false) {
					this.curIndex = this.recordIndex;
				}
			}
		},
		watch: {
			mouseInto(newValue) {
				if (newValue === false) {
					if (this.curIndex !== this.recordIndex) {
						this.curIndex = this.recordIndex;
					}
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.type-L{
		overflow: hidden;
		.type-L-item{
			width: 100%;
			display: inline-flex;
			flex-wrap: wrap;
			justify-content: space-between;
			.type-L-photo{
				display: inline-flex;
				width: 80px;
				height: 80px;
				border-radius: 50%;
				overflow: hidden;
				img{
					width: 80px;
					height: 80px;
					border-radius: 50%;
				}
			}
			.type-L-name-title{
				display: inline-flex;
				flex-wrap: wrap;
				width: calc(100% - 100px);
				height: 80px;
			}
		}
		.enter-into{
			animation: enter-into 8000ms linear forwards;
		}
		@keyframes enter-into{
			0%{
				margin-left: 100%;
			}
			4%{
				margin-left: 0;
			}
			100%{
				margin-left: 0;
			}
		}
	}
</style>
